import confetti from "canvas-confetti";
const confettiZIndex = 1000000;
export const confettiShower = () => {
    for (let i = 0; i < 10; i++) {
        setTimeout(() => {
            confettiThrow({
                angle: randomInRange(55, 125),
                spread: randomInRange(50, 70),
                particleCount: randomInRange(50, 100),
                origin: { y: 0.6 },
                zIndex: confettiZIndex,
                disableForReducedMotion: false
            });
        }, i * 100);
    }
};
export const confettiFireworks = () => {
    var duration = 3 * 1000;
    var animationEnd = Date.now() + duration;
    var particleCount = 100;
    var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };
    var interval = setInterval(function () {
        var timeLeft = animationEnd - Date.now();
        if (timeLeft <= 0) {
            return clearInterval(interval);
        }
        // since particles fall down, start a bit higher than random
        confetti({
            ...defaults,
            particleCount,
            origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
            zIndex: confettiZIndex,
            disableForReducedMotion: false
        });
        confetti({
            ...defaults,
            particleCount,
            origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
            zIndex: confettiZIndex,
            disableForReducedMotion: false
        });
    }, 250);
};
export const confettiCannons = () => {
    var end = Date.now() + 3 * 1000;
    (function frame() {
        confetti({
            particleCount: 2,
            angle: 60,
            spread: 55,
            origin: { x: 0 },
            zIndex: confettiZIndex,
            disableForReducedMotion: false
        });
        confetti({
            particleCount: 2,
            angle: 120,
            spread: 55,
            origin: { x: 1 },
            zIndex: 1000000,
            disableForReducedMotion: false
        });
        if (Date.now() < end) {
            requestAnimationFrame(frame);
        }
    })();
};
export const confettiRandom = () => {
    const confettiFunctions = [
        confettiFireworks,
        confettiCannons,
        confettiShower
    ];
    const randomIndex = Math.floor(Math.random() * confettiFunctions.length);
    confettiFunctions[randomIndex]();
};
const confettiThrow = ({ particleCount, spread, origin, angle, zIndex, disableForReducedMotion }) => {
    confetti({
        particleCount,
        spread,
        origin,
        angle,
        zIndex,
        disableForReducedMotion
    });
};
function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
}
